import { sanitizeFileName } from './sanitizeFileName';

const DEFAULT_EXTENSION = 'mp3';
const DEFAULT_BASENAME = 'audio';
const DOT_REGEX = /\./g;

const decodeSegment = (segment: string) => {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
};

export const buildSafeAudioFilename = (downloadUrl: string) => {
  const urlSegment = downloadUrl.split('/').pop()?.split('?')[0] ?? DEFAULT_BASENAME;
  const decodedSegment = decodeSegment(urlSegment);
  const sanitizedSegment = sanitizeFileName(decodedSegment || DEFAULT_BASENAME) || DEFAULT_BASENAME;
  const normalizedSegment = sanitizedSegment.replace(/-/g, '_');

  const lastDotIndex = normalizedSegment.lastIndexOf('.');
  if (lastDotIndex <= 0 || lastDotIndex === normalizedSegment.length - 1) {
    const base = normalizedSegment.replace(DOT_REGEX, '_') || DEFAULT_BASENAME;
    return `${base}.${DEFAULT_EXTENSION}`;
  }

  const namePart = normalizedSegment.slice(0, lastDotIndex).replace(DOT_REGEX, '_') || DEFAULT_BASENAME;
  const extensionPart = normalizedSegment.slice(lastDotIndex + 1).replace(DOT_REGEX, '_') || DEFAULT_EXTENSION;
  return `${namePart}.${extensionPart}`;
};
